const symbol = 'path://m 77.107143,118.59523 0.75595,-32.883922 18.520837,26.080362 24.56845,-23.812504 -4.53572,32.505944 31.08854,-3.21279 -24.47395,20.97767 24.75744,24.94643 -34.01786,-4.15774 0.37798,34.39584 -21.166668,-27.21429 -24.568454,22.3006 5.669644,-31.37202 -30.238095,2.64583 23.434524,-21.16667 -22.67857,-24.19047 z'
const solarTrajectory = [[
  { coords: [[3, 10], [4, 8.2]]  },
  { coords: [[4, 10], [5, 8.2]]  },
  { coords: [[5, 10], [6, 8.2]]  },
  { coords: [[6, 10], [7, 8.2]]  },
  { coords: [[7, 10], [8, 8.2]]  },
  { coords: [[8, 10], [9, 8.2]]  },
  { coords: [[9, 10], [10, 8.2]] }
], [
  { coords: [[5, 10], [4, 8.2]]  },
  { coords: [[5, 10], [5, 8.2]]  },
  { coords: [[5, 10], [6, 8.2]]  },
  { coords: [[5, 10], [7, 8.2]]  },
  { coords: [[5, 10], [8, 8.2]]  },
  { coords: [[5, 10], [9, 8.2]]  },
  { coords: [[5, 10], [10, 8.2]] }
]]

const rainData = _.map([[30, [1.3, 0], 0],[50, [2.5, 1.3], 5],[90, [6.5, 3.8], 8.2]], n => _.times(n[0], j => {
  const x = _.random(1, true) * n[1][0] + n[1][1]
  return { coords: [[x, 10], [x + 0.2, n[2]]] }
}))
const len = _.map(rainData, _.size)
const arr = _.flatten(_.map(rainData, (n, i) => [n.splice(0, len[i] / 2), n.splice(len[i] / 2, len[i])]))
const rainTraj = [[], [], _.map(arr, (data, i) => ({
  name: 'tail', type: 'lines', coordinateSystem: 'cartesian2d', zlevel: 1,
  effect: { show: true, constantSpeed: !(i % 2) ? 40 : 60, trailLength: .3, color: 'blue', symbolSize: 1 },
  lineStyle: { normal: { color: 'blue', width: 0, curveness: 0 } },
  data,
}))]

export {
  symbol,
  solarTrajectory,
  rainTraj
}
